import { combineReducers, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import createSagaMiddleware from "redux-saga";
import { get } from "lodash";
import { composeWithDevTools } from "redux-devtools-extension";

import sessionReducer from "./reducers/sessionReducer";
import configurationReducer from "./reducers/configurationReducer";
import menuReducer from "./reducers/menuReducer";
import errorReducer from "./reducers/errorReducer";
import viewReducer from "./reducers/viewReducer";

import { SET_ERROR } from "./actions/errorActions";
import { getAppConfig, getLanguage } from "./sagas/selectors";

/* Create root reducer, containing all features of the application */
const rootReducer = combineReducers({
    error: errorReducer,
    session: sessionReducer,
    configuration: configurationReducer,
    menu: menuReducer,
    view: viewReducer,
});

/* eslint-disable @typescript-eslint/no-use-before-define */
export const initialiseSagaMiddleware = createSagaMiddleware({
    onError: e => {
        // eslint-disable-next-line
        console.error(e);
        const state = store.getState();
        const appConfig = getAppConfig(state);
        const language = getLanguage(state);
        store.dispatch({
            type: SET_ERROR,
            error: {
                message: get(
                    appConfig,
                    `translations.${language}.fatalError`,
                    get(appConfig, "translations.EN.fatalError")
                ),
            },
        });
    },
});
/* eslint-enable @typescript-eslint/no-use-before-define */

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(initialiseSagaMiddleware, thunk)));

export type RootState = ReturnType<typeof store.getState>;
export default store;
